"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emitterLogger = void 0;

var _sbEmitter = require("./sb-emitter");

var style = 'background-color: #444444; color: white; font-height: bold;';

var emitterLogger = function emitterLogger() {
  _sbEmitter.SbEmitter.on('log', function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    console.groupCollapsed('%c[SB-EMITTER]', style, args[0]);
    args.forEach(function (arg, i) {
      if (i > 0) {
        console.log("%c[ARG-".concat(i, "]"), style, ': ', arg);
      }
    });
    console.groupEnd();
  });
};

exports.emitterLogger = emitterLogger;
//# sourceMappingURL=emitter-logger.js.map